import Loadable from 'react-loadable';

const GoalsDirectoryEmbed = Loadable<any, any>({
  loader: () => import(/* webpackChunkName: "GoalsDirectoryEmbed" */ './GoalsDirectoryEmbed'),
  loading: () => null,
});

export default GoalsDirectoryEmbed;
